import { Box, Button, Typography, useTheme, useMediaQuery } from "@mui/material";
import React from "react";
import { Header } from "../global/Header";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../Theme/theme";
import { useState } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import './CustomLinkCss.css'
import BASE_URL from "../../NetworkConfig/ApiConfig";
import { AddLinkRounded, CopyAllRounded, DeleteOutline, LinkOffRounded, LinkOutlined, Person2Rounded, RemoveRedEye, TapAndPlayRounded } from "@mui/icons-material";
import ShortLinkAddPopup from "../Utils/ShortLinkAddPopup";

const ShortLinks = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [links, setLinks] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [limit, setLimit] = useState(20)
  const [hasEnded, setHasEnded] = useState(false)
  const [totalLinks, setTotalLinks] = useState(0)
  const [showNewLinkPopup, setShowNewLinkPopup] = useState(false)

  const isMobileScreen = useMediaQuery('(max-width:500px)');
  const isTabScreen = useMediaQuery('(max-width:1200px)')


  // const [loading, setloading] = useState(true);
  const [error, seterror] = useState("Loading.....");
  const FetchData = async (page) => {
    // setloading(true);
    const token = localStorage.getItem("token");
    const response = await fetch(
      `${BASE_URL}/redir/api/shortlinks?page=${page}&limit=${limit}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "auth-token": token,
        },
      }
    );
    const data = await response.json();
    if (data.success === true) {
      setLinks(prev => page == 1 ? data.response : [...prev, ...data.response])
      setCurrentPage(page)
      setTotalLinks(data.total)
      if (data.response.length < limit) {
        setHasEnded(true)
      }
      return; // setloading(false);
    }
    if (data.success === false) {
      seterror(data.response);
    }
  };
  useEffect(() => {
    FetchData(1);
  }, []);


  const DeleteLink = async (id) => {
    // setloading(true);
    const token = localStorage.getItem("token");
    const response = await fetch(
      `${BASE_URL}/redir/api/delete`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": token,
        },
        body: JSON.stringify({
          linkId: id
        })
      }
    );
    const data = await response.json();
    if (data.success) {
      alert("Link has been deleted")
      FetchData(1)
    } else {
      alert("Failed to delete short link, please try again.")
    }

  };


  const onDeleteBtnPress = (linkId) => {

    const result = window.confirm("Are you sure you want to delete this link?");
    if (result) {
      DeleteLink(linkId)
    } else {

    }
  }

  return (
    <Box m="20px">
      <Box
        display={"flex"}
        justifyContent="space-between"
        alignItems={"center"}
        flexDirection={'row'}
        flexWrap={'wrap'}
      >
        <Header
          title={`${totalLinks == 0 ? "No" : totalLinks} Short Links`}
          subtitle={`List of short links currently active`}
          imgInc={true}
        />

        <Button
          // startIcon={<Add />}
          style={{
            width: 'max-content',
            fontSize: "13px",
            paddingLeft: "15px", paddingTop: '7px',
            paddingRight: "15px", paddingBottom: '7px',
            backgroundColor: "#ffffff15",
            borderRadius: "6px",
            border: "1px solid #ffffff25",
            textAlign: 'center',
            fontFamily: 'poppins-reg',
            textTransform: 'none'
          }}
          startIcon={<AddLinkRounded />}
          variant="contained"
          onClick={() => {
            setShowNewLinkPopup(true)
          }}
        >
          Add New Link
        </Button>
      </Box>

      <Box
        display={"grid"}
        gridTemplateColumns="repeat(12,1fr)"
        gap="20px"
        marginTop={"20px"}
        pb={"20px"}
      >
        {links &&
          links.map((link) => {
            return (
              <Box
                // key={`${transaction.txId}-${i}`}
                gridColumn={isMobileScreen ? "span 12" : isTabScreen ? "span 6" : "span 4"}
                gridRow="span 2"
                display="flex"
                alignItems="center"
                px="15px"
                py={"20px"}
                backgroundColor={"#ffffff05"}
                borderRadius={"10px"}
                sx={{
                  textDecoration: 'none',
                  flexDirection: 'column',

                }}
              >

                <Box sx={{ marginInline: "5px", display: 'flex', flexDirection: 'column', alignSelf: 'stretch', flex: 1 }}>
                  <Typography onClick={() => {
                    navigator.clipboard.writeText(`https://vybecerkle.com/r/${link.shortCode}`)
                    alert("Short link copied to clipboard.")
                  }} color={"#706dea"}
                    style={{
                      cursor: 'pointer',
                      border: "1px solid #ffffff10",
                      borderRadius: "4px",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                      paddingLeft: "12px",
                      paddingRight: "12px",
                      alignSelf: 'flex-start',
                      alignItems: 'center',
                      alignContent: 'center',
                      display: 'flex',
                      overflowWrap: 'anywhere',
                    }}
                    fontFamily={"poppins-reg"}
                    fontSize={"13px"}>https://vybecerkle.com/r/{link.shortCode}<CopyAllRounded style={{ marginLeft: "10px" }} /></Typography>

                  <Typography color={"#ffffff90"}
                    fontFamily={"poppins-reg"}
                    style={{
                      alignSelf: 'stretch',
                      marginTop: "15px",
                      overflowWrap: 'anywhere',
                    }}
                    fontSize={"12px"}>Description</Typography>

                  <Typography color={"#ffffff"}
                    fontFamily={"poppins-reg"}
                    style={{
                      alignSelf: 'stretch',
                      marginTop: "2px",
                      overflowWrap: 'anywhere',
                    }}
                    fontSize={"13px"}>{link.refString}</Typography>

                  <Box sx={{ flex: 1, display: 'flex' }} />

                  <Typography onClick={() => {
                    navigator.clipboard.writeText(link.longUrl)
                    alert("Link copied to clipboard.")
                  }} color={"#ffffff"}
                    style={{
                      cursor: 'pointer',
                      border: "1px solid #ffffff10",
                      borderRadius: "4px",
                      paddingTop: "5px",
                      paddingBottom: "5px",
                      marginTop: "20px",
                      paddingLeft: "12px",
                      paddingRight: "12px",
                      alignSelf: 'flex-start',
                      alignItems: 'center',
                      alignContent: 'center',
                      display: 'flex',
                      overflowWrap: 'anywhere',
                    }}
                    fontFamily={"poppins-reg"}
                    fontSize={"12px"}><LinkOutlined style={{ marginRight: "10px" }} />Copy Original Link</Typography>


                  <Box sx={{ flexDirection: 'column', display: 'flex', justifyContent: 'flex-end', alignSelf: 'stretch', marginTop: "20px", }}>

                    <Box sx={{ flexDirection: 'row', alignItems: 'center', alignSelf: 'stretch', display: "flex", paddingTop: "10px", borderTop: "1px solid #aaaaaa10" }}>

                      <Box sx={{ flexDirection: 'row', alignItems: 'center', display: 'flex', paddingRight: "15px", borderRight: "2px solid #ffffff10" }}>
                        <RemoveRedEye style={{ color: "#ffffff40" }} />
                        <Typography style={{
                          fontFamily: 'poppins-reg', fontSize: "12px", color: "#ffffff", marginLeft: "4px"
                        }}>{link.clicks}</Typography>
                      </Box>
                      <Box sx={{ flexDirection: 'row', alignItems: 'center', display: 'flex', paddingInline: "15px", borderRight: "2px solid #ffffff10" }}>
                        <Person2Rounded style={{ color: "#ffffff40" }} />
                        <Typography style={{
                          fontFamily: 'poppins-reg', fontSize: "12px", color: "#ffffff", marginLeft: "4px"
                        }}>{link.uniqueClicks}</Typography>
                      </Box>

                      <Box sx={{ flex: 1 }}>

                      </Box>
                      <Box onClick={() => {
                        onDeleteBtnPress(link._id)
                      }} sx={{
                        cursor: 'pointer',
                        background: "#706dea10", borderRadius: "100px", width: "30px", height: "30px", alignItems: 'center',
                        justifyContent: 'center', display: 'flex'
                      }}>
                        <DeleteOutline style={{ color: '#706dea' }} />
                      </Box>



                    </Box>
                  </Box>

                </Box>


              </Box>
            );
          })}
      </Box>

      {
        !hasEnded && (
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            alignSelf: 'stretch',
          }}>
            <Typography onClick={() => {
              FetchData(currentPage + 1)
            }} color={"#ffffff"}
              style={{
                cursor: 'pointer',
                border: "1px solid #ffffff10",
                borderRadius: "4px",
                paddingTop: "5px",
                paddingBottom: "5px",
                marginTop: "20px",
                paddingLeft: "12px",
                paddingRight: "12px",
                alignSelf: 'center',
                alignItems: 'center',
                alignContent: 'center',
                display: 'flex',
                overflowWrap: 'anywhere',
              }}
              fontFamily={"poppins-reg"}
              fontSize={"12px"}>Load More</Typography>
          </Box>
        )
      }




      <ShortLinkAddPopup open={showNewLinkPopup} onClose={() => setShowNewLinkPopup(false)} onResponse={() => {
        FetchData(1)
      }} />

    </Box>
  );
};

export default ShortLinks;
